import { lazy, Suspense, type ReactNode } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './i18n/index';

const Navbar = lazy(() => import('./components/Navbar'));
const Home = lazy(() => import('./components/Home/Home'));
const Explorer = lazy(() => import('./components/Explorer/ExplorerPage'));
const Swap = lazy(() => import('./components/Swap/SwapPage'));
const ExchangeHub = lazy(() => import('./components/Exchange/ExchangeHubPage'));
const Footer = lazy(() => import('./components/Footer'));
const ScrollToTop = lazy(() => import('./components/ScrollToTop'));

function LoadingFallback(): ReactNode {
  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-bg light:bg-gray-50">
      <div className="text-brand text-xl animate-pulse">Loading...</div>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <Suspense fallback={<LoadingFallback />}>
            {/* Bottom padding clears the fixed mobile tab bar so the footer stays
                reachable; on md+ the tab bar is replaced by the top nav. */}
            <div className="App pb-[calc(4rem+env(safe-area-inset-bottom))] md:pb-0">
              <Navbar />
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/explorer" element={<Explorer />} />
                <Route path="/swap" element={<Swap />} />
                <Route path="/exchange" element={<ExchangeHub />} />
                {/* The bridge is a tab of /exchange now. Old links — and anything that
                    bookmarked the page — land on the same screen instead of a second
                    copy of it. */}
                <Route path="/bridge" element={<Navigate to="/exchange?tab=bridge" replace />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <Footer />
            </div>
          </Suspense>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
